import {
  WRITE_KEY_STORAGE_PREFIX,
  readUserScoped,
  removeUserScoped,
  writeUserScoped,
} from '@/shared/storage/client-storage';

/**
 * YİNELEME ANAHTARININ KALICI KOPYASI (C17 · sıra 13).
 *
 * Redux'taki anahtar sayfa yenilemesinde kayboluyordu: yanıt koptuktan sonra
 * personel sayfayı yenileyip aynı bilgilerle yeniden gönderince yeni anahtar
 * gidiyor, sunucu ikinci kredi satırını yazıyordu. Kopya kapsama bağlı yazılır,
 * başarı ya da kesin ret onu siler, oturum sınırında `clearUserScopedStorage`
 * temizler.
 *
 * Süre sınırı: sunucudaki anahtar kalıcıdır. Unutulmuş bir kopya günler sonra
 * aynı gövdeyle bilerek yapılan yeni yüklemeyi eski sonuca bağlamasın diye
 * kopya bir günden eskiyse yok sayılır.
 *
 * Ham gövde DİSKE YAZILMAZ: imza sahip e-postası, iletişim adresi ve serbest
 * gerekçe metni taşır. Kalıcı kopyada yalnız imzanın özeti ve UUID anahtar durur.
 */
export const WRITE_KEY_TTL_MS = 24 * 60 * 60 * 1000;

export interface StoredWriteKey {
  readonly digest: string;
  readonly key: string;
}

/** Gövde imzasının kriptografik olmayan özeti (cyrb53): eşleşme için, gizlilik için değil. */
export function signatureDigest(signature: string): string {
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < signature.length; i += 1) {
    const ch = signature.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(16);
}

function storageKey(scope: string): string {
  return `${WRITE_KEY_STORAGE_PREFIX}${scope}`;
}

export function readStoredWriteKey(scope: string, now = Date.now()): StoredWriteKey | null {
  const raw = readUserScoped(storageKey(scope));
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<StoredWriteKey & { issuedAt: number }>;
    if (typeof parsed.digest !== 'string' || typeof parsed.key !== 'string') return null;
    if (typeof parsed.issuedAt !== 'number' || now - parsed.issuedAt > WRITE_KEY_TTL_MS) {
      return null;
    }
    return { digest: parsed.digest, key: parsed.key };
  } catch {
    return null;
  }
}

export function storeWriteKey(scope: string, entry: StoredWriteKey, now = Date.now()): void {
  writeUserScoped(storageKey(scope), JSON.stringify({ ...entry, issuedAt: now }));
}

export function forgetWriteKey(scope: string): void {
  removeUserScoped(storageKey(scope));
}
